module.exports = __webpack_public_path__ + "static/media/cucinagourmet.39991df9.png";